import React from 'react';

const ProgramFilter = ({ programs, selectedProgramId, onChange, label = 'All Programs' }) => (
  <select
    value={selectedProgramId}
    onChange={(e) => onChange(e.target.value)}
    className="px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
  >
    <option value="">{label}</option>
    {programs.map(p => (
      <option key={p.id} value={p.id}>{p.name}</option>
    ))}
  </select>
);

export default ProgramFilter;